const Dashboard = () => {
  return (
    <div className="p-20">
      <h1 style={{color:"red"}}>No Page Found!</h1>
    </div>
  );
};

export default Dashboard;